import { render } from "./introduction.vue?vue&type=template&id=403e6686"
import script from "./introduction.vue?vue&type=script&lang=js"
export * from "./introduction.vue?vue&type=script&lang=js"
script.render = render

export default script